export const portfolioFilter = [
	{ text: "portfolio.all", value: "all" },
	{ text: "portfolio.angular", value: "angular" },
	{ text: "portfolio.react", value: "reactjs" },
	{ text: "portfolio.vue", value: "vuejs" }
];